import { Route, Switch } from 'react-router-dom';
import { requestSinglePageRoutes } from '../../routesConfig';
import { MainPage, ErrorPage } from './pages';

export const Routes = () => {
  const { main, error } = requestSinglePageRoutes.request_single_page;

  return (
    <Switch>
      <Route path={main.link} component={MainPage} />
      <Route path={error.link} component={ErrorPage} />
    </Switch>
  );
};
